import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  getNow(): Date {
    return new Date();
  }
}
